import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as archivedSelfieState from '../employee-detail.reducer';
import * as archivedSelfieReducer from '../reducers/archived-selfie.reducer';

export const getArchivedSelfieSelector = createSelector(
  archivedSelfieState.getArchivedSelfiesState,
  archivedSelfieReducer.getPreviousSelfies
);
